





















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalEdit from './ModalEdit.vue'
import { AdminCMSModule } from '@/app/store/modules/adminCMS'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-edit': ModalEdit,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public dataTable
  @Prop({}) public isLoading

  public modalDelete = {
    id: 'modal-delete',
    idCategory: 0,
    categoryName: '',
  }

  // Form Edit
  public id: number = 0
  public name = ''
  public email = ''
  public roleName = ''
  public roleId: number = 0
  public phone = ''
  public password = ''

  public $refs!: {
    selectableTable: HTMLFormElement
  }

  public funcEdit(item, index, button) {
    //  console.log('ITEM TO EDIT', item)
    this.id = item.id
    this.name = item.name
    this.email = item.email
    this.roleName = item.roleName
    this.roleId = item.roleId
    this.phone = item.phone
    this.password = item.password
    this.$root.$emit('bv::show::modal', 'edit-notification', button)
  }
  public async patchNotif(item, index, button) {
    const dataToEdit = {
      id: this.id,
      name: this.name,
      email: this.email,
      role_id: 1,
      phone: this.phone,
      password: this.password,
    }

    AdminCMSModule.updateUser(dataToEdit)
    this.$root.$emit('bv::hide::modal', 'edit-notification', button)
  }

  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }

  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }

  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  public funcDelete(item, index, button) {
    //  console.log('user delete', item)
    if (this.$props.selected.length < 1) {
      this.modalDelete.categoryName = item.name
      this.modalDelete.idCategory = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idCategory]
    AdminCMSModule.deleteUser({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }
}
